import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-slides', 'titleNav', 'Навигация по слайдам');
Labels.set('ui-slides', 'prev', 'Предыдущий');
Labels.set('ui-slides', 'next', 'Следующий');
Labels.set('ui-slides', 'slide', 'Слайд');
